import React from "react";
import * as yup from "yup";
import { SubmitHandler, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Validation } from "../../localization/localeValidation";
import ajaxClient, { MaxServerError } from "../../../../js/common/AjaxClient";
import popupAlertService from "../../../../js/common/PopupAlertService";

interface PushCategoryResponse {
    readonly error: boolean;
    readonly message?: string;
}

interface SubscribeMutationParameters {
    readonly email: string;
    readonly packageCategoryId: number;
}

const packageCategoryWatchdogFormSchema = yup.object({
    email: yup.string().lowercase()
        .trim()
        .required("Zadejte prosím Váš e-mail.")
        .matches(Validation.EmailRegEx, "Zadejte prosím platný e-mail"),
});

export type PackageCategoryWatchdogFormData = yup.InferType<typeof packageCategoryWatchdogFormSchema>;

const pushCategorySubscribe = async (data: SubscribeMutationParameters): Promise<void> => {
    await ajaxClient.post<PushCategoryResponse>("/EshopWatchdog/jsSubscribeCategoryWatchdog", data);
};

interface PackageCategoryWatchdogFormProperties {
    readonly packageCategoryId: number;
    readonly packageCategoryTitle: string;
    readonly onSubscribed: () => void;
}

export default function PackageCategoryWatchdogForm({
    packageCategoryId,
    packageCategoryTitle,
    onSubscribed,
}: PackageCategoryWatchdogFormProperties): React.JSX.Element {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm<PackageCategoryWatchdogFormData>({
        resolver: yupResolver(packageCategoryWatchdogFormSchema),
        defaultValues: {
            email: "@",
        },
    });
    const onSubmit: SubmitHandler<PackageCategoryWatchdogFormData> = async (data: PackageCategoryWatchdogFormData): Promise<void> => {
        try {
            await pushCategorySubscribe({ email: data.email, packageCategoryId: packageCategoryId });
            onSubscribed();
        } catch (error) {
            if (error instanceof MaxServerError) {
                void popupAlertService.showAlert(error.message);

                return;
            }

            throw error;
        }
    };

    return (
        <div className="watchdog-set">
            <div className="well well-transparent">
                <div className="product-row">
                    <p className="fakeh3">Hlídání novinek v této kategorii</p>
                    <p>Zadejte mi svůj e-mail a já vám pošlu e-mail každý den, kdy se v kategorii <span>{packageCategoryTitle}</span> objeví něco
                        nového.
                    </p>
                    <div className="watchdog-container">
                        <img src="https://cdn.odkarla.cz/css/image/watchdog-pes-v1.png" alt="" />
                        <div className="watchdog-inner-form">
                            <form onSubmit={(event): void => void handleSubmit(onSubmit)(event)}>
                                <div className="form-group">
                                    <div className="input-form-mandatory" aria-required="true">
                                        <input
                                            {...register("email")}
                                            autoFocus
                                            className="form-control"
                                            placeholder="Zadejte Váš e-mail"
                                            id="categoryWatchdog_email"
                                        />
                                        <label htmlFor="categoryWatchdog_email" className="error">{errors.email?.message}</label>
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-success btn-sm">Karle, hlídej</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
